var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group-row',{attrs:{"form":_vm.form,"label":_vm.label,"name":_vm.name,"required":""}},[_c('form-input',{attrs:{"form":_vm.form,"name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }